import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
    andAllWhere,
    andWhere,
    buildQuery,
    FilterFn,
    noop,
    Ops,
    orderBy,
    OrderVariant,
    orWhere,
    page,
    where
} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "../../../../../../environments/environment.prod";
import { ExpenseAttributes, OrderAttributes } from "@albatrosdeveloper/ave-models-package";
import { IPagination, IPaginationResult } from "app/common/interfaces";
import { IFilters } from "app/modules/components/filters/interfaces/filterInterface";

const apiUrl = env.API_CSM_PAYMENT_ORDER_URL;
const moduleName = "expense"
@Injectable({
    providedIn: "root",
})
export class ExpenseService extends AbstractService<ExpenseAttributes, ExpenseAttributes, ExpenseAttributes> {
    /** The last filter used to load the list */

    constructor(
        http: HttpClient,
    ) {
        super(apiUrl, moduleName, http);
    }

    findAllWithCount(
        options: IPagination<ExpenseAttributes>,
        dataToFilter: IFilters,
    ): Observable<IPaginationResult<ExpenseAttributes>> {
        const arrayQueries: FilterFn<ExpenseAttributes>[] = [];

        if (options.search) {
            const searchTerm = options.search ?? "";

            arrayQueries.push(
                andWhere("subRoute.name" as keyof ExpenseAttributes, Ops.like(searchTerm, "i")),
                orWhere("user.user_login.username" as keyof ExpenseAttributes, Ops.like(searchTerm, "i")),
                orWhere("serial", Ops.like(searchTerm, "i")),
            )
        }

        if (dataToFilter?.tripId) {
            arrayQueries.push(andAllWhere("trip.id" as keyof ExpenseAttributes, Ops.eq(dataToFilter.tripId)))
        }

        if (dataToFilter?.expenseReasonsName || dataToFilter?.expenseReasonsName != "") {
            arrayQueries.push(andAllWhere("reasonForExpense.name" as keyof ExpenseAttributes, Ops.eq(dataToFilter.expenseReasonsName)))
        }

        if (dataToFilter?.expenseReason && dataToFilter?.expenseReason.length > 0) {
            arrayQueries.push(andAllWhere("reasonForExpense.id" as keyof ExpenseAttributes, Ops.in(...dataToFilter.expenseReason)))
        }

        if (dataToFilter?.seller && dataToFilter?.seller.length > 0) {
            arrayQueries.push(andAllWhere("user.user_login.username" as keyof ExpenseAttributes, Ops.in(...dataToFilter.seller)))
        }

        if (dataToFilter?.statusERP && dataToFilter?.statusERP.length > 0 && !dataToFilter?.statusERP.includes(null)) {
            arrayQueries.push(andAllWhere('statusERP', Ops.in(...dataToFilter.statusERP)))
        }

        if (dataToFilter?.status && dataToFilter?.status.length > 0 && !dataToFilter.status.includes(null)) {
            arrayQueries.push(andAllWhere('statusId', Ops.in(...dataToFilter.status)))
        }

        if (dataToFilter?.subRouteId && dataToFilter?.subRouteId.length > 0) {
            arrayQueries.push(andAllWhere('subRoute.id' as keyof ExpenseAttributes, Ops.in(...dataToFilter.subRouteId)))
        }

        const query = buildQuery<ExpenseAttributes>(
            where('_deleted', Ops.eq(false)),

            dataToFilter?.startDate && dataToFilter?.endDate
                ? andAllWhere("createdAt", Ops.btwnDates(dataToFilter.startDate, dataToFilter.endDate))
                : noop(),
            
            ...arrayQueries,

            orderBy(
                options.sort ?? "_id",
                options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
            ),
            page(options.currentPage ?? 1, options.limitPerPage ?? 100)
        );

        const API_URL: string = apiUrl + `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;

        return this.http.get<IPaginationResult<ExpenseAttributes>>(API_URL);
    }
}
